import { useReducer } from 'react';
import { isLength } from 'validator';

// const emojiRegexExceptHeart = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u2660]|[\u2662-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
const emojiRegexExceptHeart = /[^(a-zA-Z)|^(0-9)|^(ㄱ-ㅎ)|^(ㅏ-ㅣ)|^(가-힣)|^( ~!@#$&*()_+=,.?♥♡:;"')|^(\u119E\u11A2\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55\u4E10\u3163\u3161)]/g; // 영어, 숫자, 한글 자음, 한글 모음, 완성형 한글, 일부 특수기호, 천지인 키보드
const fillHeart = '♥';
export function convertAllEmojiToHeartEmoji(message) {
  return message.replace(emojiRegexExceptHeart, fillHeart);
}

function reducer(state, action) {
  switch (action.type) {
    case 'ON-CHANGE-WHEN-VALID':
      let valid = false;
      if (isLength(action.value, { max: 20 })) valid = true;
      return {
        ...state,
        message: convertAllEmojiToHeartEmoji(action.value),
        messageValid: valid,
      };
    case 'SET-VALUE':
      return {
        ...state,
        message: action.value,
      };
    default:
      throw new Error();
  }
}

export default function MessageReducer(defaultValue) {
  const [state, dispatch] = useReducer(reducer, defaultValue);
  const onChange = ({ message }) => {
    dispatch({
      type: 'ON-CHANGE-WHEN-VALID',
      value: message,
    });
  };
  const setValue = ({ message }) => {
    dispatch({ type: 'SET-VALUE', value: message });
  };
  return [state, setValue, onChange];
}
